import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Button } from "antd";
import { PictureOutlined } from "@ant-design/icons";

const Wrap = styled.div`
  position: relative;
  display: grid;
  gap: 8px;
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas:
    "main s1 s2"
    "main s3 s4";
  border-radius: 12px;
  overflow: hidden;
`;

const Cell = styled.div`
  border-radius: 12px;
  overflow: hidden;
  background: #f2f2f2;
  aspect-ratio: 4/3;
  &.main {
    grid-area: main;
    aspect-ratio: auto;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const ShowAll = styled(Button)`
  position: absolute !important;
  right: 12px;
  bottom: 12px;
  border-radius: 8px;
  font-weight: 600;
`;

export default function Gallery({ images, onShowAll }) {
  if (!images || !images.length) return null;
  const list =
    images.length >= 5
      ? images.slice(0, 5)
      : [
          ...images,
          ...Array(5 - images.length).fill(images[images.length - 1]),
        ];

  return (
    <Wrap>
      <Cell className="main">
        <img src={list[0]} alt="Main" />
      </Cell>
      {[1, 2, 3, 4].map((i) => (
        <Cell key={i}>
          <img src={list[i]} alt={`gallery ${i + 1}`} />
        </Cell>
      ))}
      <ShowAll icon={<PictureOutlined />} size="large" onClick={onShowAll}>
        Show all photos
      </ShowAll>
    </Wrap>
  );
}

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  onShowAll: PropTypes.func,
};
